// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdPopup_wrapper__6D5t_","popup":"AdPopup_popup__9x0hq","img":"AdPopup_img__FnSLK","close":"AdPopup_close__g1eJ6"};